import { useCallback } from 'react'
import {
	AnyObject,
	ObjectShape,
	OptionalObjectSchema,
	TypeOfShape,
} from 'yup/lib/object'

/* eslint-disable-next-line @typescript-eslint/explicit-function-return-type */
function useYupValidation(
	validationSchema: OptionalObjectSchema<
		ObjectShape,
		AnyObject,
		TypeOfShape<ObjectShape>
	>,
) {
	return useCallback(
		async (data: AnyObject) => {
			try {
				const values = await validationSchema.validate(data, {
					abortEarly: false,
				})

				return {
					values,
					errors: {},
				}
			} catch (errors) {
				const newError: { inner: [] } = errors as { inner: [] }
				return {
					values: {},
					errors: newError.inner.reduce(
						(
							allErrors: object,
							currentError: {
								path: string
								type: string
								message: string
							},
						) => ({
							...allErrors,
							[currentError.path]: {
								type: currentError.type ?? 'validation',
								message: currentError.message,
							},
						}),
						{},
					),
				}
			}
		},
		[validationSchema],
	)
}

export default useYupValidation
